<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mt-5 cursor-pointer" :class="{show: expanded}" @click="toggle">
            <h3>Bedrijfgegevens</h3>
            <i class="far fa-angle-down lead"></i>
        </div>
        <transition-slide-toggle>
            <form @submit.prevent="submit" novalidate v-show="expanded" class="accordion-body" ref="form">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.company.$error}">
                            <label for="company-5bc4960" class="control-label">Bedrijfsnaam</label>
                            <input type="text" id="company-5bc4960" class="form-control" v-model.trim.lazy="$v.form.company.$model">
                            <div class="help-text" v-if="$v.form.company.$error">
                                <p v-if="!$v.form.company.required">Dit veld is verplicht</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.kvk.$error}">
                            <label for="kvk-5bc4960" class="control-label">Kvk nummer</label>
                            <input type="text" id="kvk-5bc4960" class="form-control" v-model.trim.lazy="$v.form.kvk.$model">
                            <div class="help-text" v-if="$v.form.kvk.$error">
                                <p v-if="!$v.form.kvk.required">Dit veld is verplicht</p>
                                <p v-if="!$v.form.kvk.minLength">Geen geldig telefoonnummer</p>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="mb-2"><strong>Hoofdvestiging</strong></p>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.address.$error}">
                            <label for="address-5bc4960" class="control-label">Adres</label>
                            <input type="text" id="address-5bc4960" class="form-control" v-model.trim.lazy="$v.form.address.$model">
                            <div class="help-text" v-if="$v.form.address.$error">
                                <p v-if="!$v.form.address.required">Dit veld is verplicht</p>
                                <p v-if="!$v.form.address.minLength || !$v.form.address.maxLength">Geen geldig adres</p>
                            </div>
                        </div>
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.city.$error}">
                            <label for="city-5bc4960" class="control-label">Plaatsnaam</label>
                            <input type="text" id="city-5bc4960" class="form-control" v-model.trim.lazy="$v.form.city.$model">
                            <div class="help-text" v-if="$v.form.city.$error">
                                <p v-if="!$v.form.city.required">Dit veld is verplicht</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.zip.$error}">
                            <label for="zip-5bc4960" class="control-label">Postcode</label>
                            <input type="text" id="zip-5bc4960" class="form-control" v-model.trim.lazy="$v.form.zip.$model">
                            <div class="help-text" v-if="$v.form.zip.$error">
                                <p v-if="!$v.form.zip.required">Dit veld is verplicht</p>
                            </div>
                        </div>
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.company_type.$error}">
                            <label for="company_type-5bc4960" class="control-label">Typering bedrijf</label>
                            <select id="company_type-5bc4960" class="form-control" v-model.trim.lazy="$v.form.company_type.$model">
                                <option :value="value" v-for="(label, value) in companyTypes" :key="value">{{ label }}</option>
                            </select>
                            <div class="help-text" v-if="$v.form.company_type.$error">
                                <p v-if="!$v.form.company_type.required">Dit veld is verplicht</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group" :class="{'error-shake has-invalid': $v.form.multi_select_values.$error}">
                            <label class="typo__label">Typering sector</label>
                            <multiselect v-model="form.multi_select_values" :options="options" :multiple="true" :allow-empty="false"
                                         group-values="libs" group-label="sector" :group-select="true"
                                         selectLabel="Selecteer met enter" selectGroupLabel="Selecteer groep met enter" selectedLabel="Geselecteerd"
                                         deselectLabel="Verwijder met enter" deselectGroupLabel="Verwijder groep met enter" placeholder="Typ om te zoeken"
                                         track-by="name" label="name">
                                <span slot="noResult">Niets gevonden.</span>
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div v-for="(v, index) in $v.form.locations.$each.$iter" v-if="form.locations" :key="index">
                    <p class="mb-2"><strong>Extra vestiging ({{ parseInt(index) + 1 }})</strong></p>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group" :class="{'error-shake has-invalid': v.address.$error}">
                                <label :for="'address-' + index" class="control-label">Adres</label>
                                <input type="text" :id="'address-' + index" class="form-control" v-model.trim.lazy="v.address.$model">
                                <div class="help-text" v-if="v.address.$error">
                                    <p v-if="!v.address.required">Dit veld is verplicht</p>
                                </div>
                            </div>
                            <div class="form-group" :class="{'error-shake has-invalid': v.city.$error}">
                                <label :for="'city-' + index" class="control-label">Plaatsnaam</label>
                                <input type="text" :id="'city-' + index" class="form-control" v-model.trim.lazy="v.city.$model">
                                <div class="help-text" v-if="v.city.$error">
                                    <p v-if="!v.city.required">Dit veld is verplicht</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group" :class="{'error-shake has-invalid': v.zip.$error}">
                                <label :for="'zip-' + index" class="control-label">Postcode</label>
                                <input type="text" :id="'zip-' + index" class="form-control" v-model.trim.lazy="v.zip.$model">
                                <div class="help-text" v-if="v.zip.$error">
                                    <p v-if="!v.zip.required">Dit veld is verplicht</p>
                                </div>
                            </div>
                            <div class="form-group" :class="{'error-shake has-invalid': v.company_type.$error}">
                                <label :for="'company_type-' + index" class="control-label">Typering vestiging</label>
                                <select :id="'company_type-' + index" class="form-control" v-model.trim.lazy="v.company_type.$model">
                                    <option :value="value" v-for="(label, value) in companyTypes" :key="value">{{ label }}</option>
                                </select>
                                <div class="help-text" v-if="v.company_type.$error">
                                    <p v-if="!v.company_type.required">Dit veld is verplicht</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group" :class="{'error-shake has-invalid': v.multi_select_values.$error}">
                                <label class="typo__label">Typering sector</label>
                                <multiselect v-model="form.locations[index].multi_select_values" :options="options" :multiple="true" :allow-empty="false"
                                             group-values="libs" group-label="sector" :group-select="true"
                                             selectLabel="Selecteer met enter" selectGroupLabel="Selecteer groep met enter" selectedLabel="Geselecteerd"
                                             deselectLabel="Verwijder met enter" deselectGroupLabel="Verwijder groep met enter" placeholder="Typ om te zoeken"
                                             track-by="name" label="name">
                                    <span slot="noResult">Niets gevonden.</span>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <button type="button" class="btn btn-link-small" @click="addLocation" ref="btnAddLocation"><i class="fas fa-plus-circle mr-1"></i>Vestiging toevoegen</button>
                </div>
                <button type="submit" class="btn btn-primary btn-caret btn-sm mr-4 mb-3 mb-md-0" ref="btnSubmit">Gegevens aanpassen</button>
            </form>
        </transition-slide-toggle>
    </div>
</template>

<script>
    import {required, minLength, maxLength} from 'vuelidate/lib/validators'
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Multiselect,
        },
        props: {
            data: Object,
            companyTypes: Object,
            sectorTypes: Object,
            btnStartLoading: Function,
            btnFinishLoading: Function,
        },
        data() {
            return {
                expanded: false,
                form: {
                    company: this.data.company,
                    kvk: this.data.kvk,
                    address: this.data.address,
                    zip: this.data.zip,
                    city: this.data.city,
                    company_type: this.data.company_type,
                    sector_type: this.data.sector_type,
                    locations: this.data.locations,
                    multi_select_values: [],
                },

                options: [],
            }
        },
        validations: {
            form: {
                company: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(255),
                },
                kvk: {
                    required,
                    minLength: minLength(5),
                },
                address: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(255),
                },
                zip: {
                    required,
                    minLength: minLength(2),
                },
                city: {
                    required,
                },
                company_type: {
                    required,
                },
                multi_select_values: {
                    required
                },
                locations: {
                    $each: {
                        address: {
                            required,
                            minLength: minLength(2),
                            maxLength: maxLength(255),
                        },
                        zip: {
                            required,
                            minLength: minLength(2),
                        },
                        city: {
                            required,
                        },
                        company_type: {
                            required,
                        },
                        multi_select_values: {
                            required
                        },
                    }
                },
            }
        },
        created() {
            this.options = _.map(this.sectorTypes);

            this.data.sector_type.forEach(sector => {
                this.form.multi_select_values.push({name: sector});
            });

            this.data.locations.forEach(location => {
                location.sector_type.forEach(sector => {
                    location.multi_select_values.push({name: sector});
                })
            });
        },
        methods: {
            submit() {
                this.$refs.btnSubmit.blur();
                this.$v.$touch();

                if (this.$v.$anyDirty && !this.$v.$invalid) {
                    this.btnStartLoading(this.$refs.btnSubmit);

                    let that = this;
                    this.axios.post('/users/company', this.form).then(() => {
                        that.$notify({
                            group: 'base',
                            text: 'Uw bedrijfsgegevens zijn opgeslagen.',
                            type: 'alert-info',
                        });

                        this.btnFinishLoading(this.$refs.btnSubmit, true);
                    }).catch(error => {
                        that.$notify({
                            group: 'base',
                            text: 'Er is een fout opgetreden.',
                            type: 'alert-danger',
                        });

                        that.btnFinishLoading(this.$refs.btnSubmit);

                        console.error(error);
                    });
                }
            },
            toggle() {
                this.expanded = !this.expanded;
            },
            addLocation() {
                this.$refs.btnAddLocation.blur();

                if (!Array.isArray(this.form.locations)) {
                    this.form.locations = [];
                }

                this.form.locations.push({
                    address: '',
                    zip: '',
                    city: '',
                    company_type: '',
                    sector_type: [],
                    multi_select_values: [],
                });
            },
        },
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
